module.exports = __webpack_public_path__ + "media/images/sms-messaging-on-56ee1bd2cb9979ac81efcb0560fe15ed.png";